<ngx-spinner type="ball-clip-rotate"></ngx-spinner>

<ng-container *ngIf="initialized">
  <div *ngIf="page === 'login'">
    <app-dr-dish-login></app-dr-dish-login>
  </div>

  <div *ngIf="page === 'register'">
    <app-dr-dish-register></app-dr-dish-register>
  </div>

  <div *ngIf="page === 'forgot-password'">
    <app-dr-dish-forgot-password></app-dr-dish-forgot-password>
  </div>

  <!-- 送信しましたページ -->
  <div *ngIf="page === 'password-reset-send'">
    <app-dr-dish-change-password-sent></app-dr-dish-change-password-sent>
  </div>

  <app-dr-dish-register-resend
    *ngIf="page === 'register-resend'"
  ></app-dr-dish-register-resend>
</ng-container>
